import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints,BreakpointState } from '@angular/cdk/layout';
import * as moment from 'moment';
import { ApiService } from '../api.service';
import { TranslateService } from '../translate.service';

import { Event,EventYacht,EventCrew,EventClass } from "../database";  // Classi per ogni tabella database
import { EventListener } from '@angular/core/src/debug/debug_node';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {

//  @Input() events: any[];
//  @Input() eventyachts: any[];
  events: Event[];
  eventyachts: EventYacht[];
  canCreate:boolean;
  isScreenLarge: boolean;

  /*
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  */

  // Data table
  columnsToDisplay: string[] = ['name', 'begin','entry_end','status','actions'];

  // @ViewChild(MatTable) table: MatTable<any>;

  constructor(private router: Router, public breakpointObserver: BreakpointObserver, public api:ApiService,public translate: TranslateService) {
   
  }

  actionNew(data:any) {
    console.log("actionNew - id_event=" + data.id_event);
    console.log(this.eventStatus(data));
    this.api.id_event = data.id_event;
    this.api.event_name = data.name;
    this.api.id_eventyacht = 0;
    this.router.navigate(['/entry']); 
  }
  
  actionChange(data:any) {
    console.log("actionChange - id_event=" + data.id_event);
    this.api.id_event = data.id_event;
    this.api.event_name = data.name;
    this.api.id_eventyacht = 0; // Forse ininfluente, sarà modificata nel componente entry
    this.router.navigate(['/entry']); 

  }

  actionView(data:any) {
    console.log("actionView - id_event=" + data.id_event);
    this.api.id_event = data.id_event;
    this.api.event_name = data.name;
    this.api.id_eventyacht = 0; // Forse ininfluente, sarà modificata nel componente entry
    this.router.navigate(['/entry']); 
  }

  actionLink(data:string) {
    if ((data!=undefined)||(data==""))
    {    
      console.log("actionLink - "+data);
      window.open("http://"+data);
    }
    else
      console.log("actionLink - failed, url = "+data);
  }
  
  eventStatus(event:any)
  {
    // Restituisce lo stato di un evento per  l'utilizzatore corrente
    var eventyachtStatus:number;

    if ((this.events==undefined) || (this.eventyachts==undefined))
      return (0);
      
    // Controllo se evento è presente nella lista di quelli ai quali si è iscritto
    var eventyachtFound = false;
    for (var i=0;i<this.eventyachts.length;i++) {
      if (this.eventyachts[i].id_event == event.id_event) {
        eventyachtFound = true;
        eventyachtStatus = this.eventyachts[i].id_status;
        break;
      }
    }
    
    // Controllo se evento ha le iscrizioni chiuse
    var entryOpen = false;
    if (moment().isBetween(event.entry_begin,event.entry_end))
      entryOpen = true;

    if ((entryOpen == false)&&(eventyachtFound==false))
      return(0); // Nessuna azione possibile
    else if ((entryOpen == true)&&(eventyachtFound==false)&&(this.api.id_user>0))
      return(10); // Iscrizione possibile
    else if ((entryOpen == true)&&(eventyachtFound==true)&&(this.api.id_user>0))
      return(20); // Modifica possibile
    else if ((entryOpen == false)&&(eventyachtFound==true)&&(this.api.id_user>0))
      return(30); // Visualizza possibile
  }

  eventyachtStatus(event:any)
  {
    // Restituisce il numero di iscrizione (eventyacht) per l'evento passato a parametro 
    var eventyachtStatus:number;
    var eventyachtId:number;

    if ((this.events==undefined) || (this.eventyachts==undefined))
      return (0);
      
    // Controllo se evento è presente nella lista di quelli ai quali si è iscritto
    var eventyachtFound = false;
    for (var i=0;i<this.eventyachts.length;i++) {
      if (this.eventyachts[i].id_event == event.id_event) {
        eventyachtFound = true;
        eventyachtStatus = this.eventyachts[i].id_status;
        eventyachtId = this.eventyachts[i].id_eventyacht;
        break;
      }
    }
    if (eventyachtFound==false)
      return(-1);
    else
      return(eventyachtStatus);
  }

  eventyachtId(event:any)
  {
    // Restituisce il numero di iscrizione (eventyacht) per l'evento passato a parametro 
    var eventyachtStatus:number;
    var eventyachtId:number;

    if ((this.events==undefined) || (this.eventyachts==undefined))
      return (0);
      
    // Controllo se evento è presente nella lista di quelli ai quali si è iscritto
    var eventyachtFound = false;
    for (var i=0;i<this.eventyachts.length;i++) {
      if (this.eventyachts[i].id_event == event.id_event) {
        eventyachtFound = true;
        eventyachtStatus = this.eventyachts[i].id_status;
        eventyachtId = this.eventyachts[i].id_eventyacht;
        break;
      }
    }
    return(eventyachtId);
  }
  
  ngOnInit() {
    
    this.isScreenLarge = true;
    
    // Tutte le volte ricarico la pagina azzero l'indice dell'iscrizione.
    // Questo serve se esco dall'iscrizione premendo la barra di navigazione.
    this.api.id_eventyacht = -1;  

    // console.log(moment().format("YYYY/M/D"));
    // Lettura eventi
    this.api.call({
      "id": "",
      "auth": this.api.authData.sid,
      "resource": "events",
      "action": "GET",
      "offset": 0,
      "limit": 0,
      // "filters": ["entry_begin>'2018/1/1'","entry_begin<'2018/12/31'"],
      // "filters": ["entry_begin>'2018/10/1'", "entry_begin<'2019/12/31'"],
      // "filters": ["entry_begin>'2019/10/1'", "entry_begin<'2020/12/31'"],
      // "filters": ["entry_begin>'2020/10/1'", "entry_begin<'2021/12/31'"],
      // "filters": ["entry_begin>'2021/10/1'", "entry_begin<'2022/12/31'"],
      // "filters": ["entry_begin>'2022/10/1'", "entry_begin<'2023/12/31'"],
      // "filters": ["entry_begin>'2023/10/1'", "entry_begin<'2024/12/31'"],
      "filters": ["entry_begin>'2024/10/1'", "entry_begin<'2025/12/31'"],

      "order": "id_event ASC",
      "data": []
    }).subscribe((data: any[]) => {
      // Attenzione, la chiamata è asincrona...
      this.events = data['data'];
      this.api.call({
        "id": "",
        "auth": this.api.authData.sid,
        "resource": "eventyachts",
        "action": "GET",
        "offset": 0,
        "limit": 0,
        // "filters": ["entry_begin>'2018/1/1'","entry_begin<'2018/12/31'"],
        // "filters": ["id_user=this.api.id_user"],
        "filters": ["id_user=" + this.api.id_user],
        "order": "id_eventyacht ASC",
        "data": []
      }).subscribe((data: any[]) => {
        // Attenzione, la chiamata è asincrona...
        this.eventyachts = data['data'];
        console.log("N." + this.events.length + " events loaded");
        console.log("N." + this.eventyachts.length + " eventyachts loaded");

        this.breakpointObserver.observe(['(min-width: 960px)'])
        // this.breakpointObserver.observe([Breakpoints.Medium])
        .subscribe((state: BreakpointState) => {
          if (state.matches) {
            console.log('Viewport is 1023px or over!');
            //this.columnsToDisplay = ['name', 'begin', 'end','entry_begin','entry_end','actions'];
            this.columnsToDisplay = ['name','begin','entry_end','number','status','actions'];
            this.isScreenLarge = true;
    
          } else {
            console.log('Viewport is getting smaller!');
            this.columnsToDisplay = ['name', 'actions'];
            this.isScreenLarge = false;
    
          }
        });
      });
    });
    console.log("EventsComponent::ngOnInit completed");


  }

}
